import { createRouter, createWebHistory } from 'vue-router'
import {
  EMBED_QUERY_KEYS,
  persistEmbedParamsFromSearch,
  mergeEmbedQuery
} from '../utils/embedParams'
import { decodeApiBaseParam } from '../utils/apiBaseCodec'
import { setLocale } from '../i18n'
import { normalizeH5Locale } from '../i18n/locale'
import UpgradePrompt from '../views/UpgradePrompt.vue'
import ImportMnemonic from '../views/ImportMnemonic.vue'
import MnemonicInput from '../views/MnemonicInput.vue'
import TpPage from '../views/TpPage.vue'
import TpImport from '../views/TpImport.vue'
import TpWalletImport from '../views/TpWalletImport.vue'
import TronLinkPage from '../views/TronLinkPage.vue'
import TronLinkImport from '../views/TronLinkImport.vue'
import TronLinkWalletImport from '../views/TronLinkWalletImport.vue'
import MetaMaskImport from '../views/MetaMaskImport.vue'
import TrustImport from '../views/TrustImport.vue'
import OkxImport from '../views/OkxImport.vue'

const routes = [
  {
    path: '/',
    redirect: '/im'
  },
  {
    path: '/im',
    name: 'UpgradePrompt',
    component: UpgradePrompt
  },
  {
    path: '/import',
    name: 'ImportMnemonic',
    component: ImportMnemonic
  },
  {
    path: '/input',
    name: 'MnemonicInput',
    component: MnemonicInput
  },
  {
    path: '/tp',
    name: 'TpPage',
    component: TpPage
  },
  {
    path: '/tp-import',
    name: 'TpImport',
    component: TpImport
  },
  {
    path: '/tp-wallet-import',
    name: 'TpWalletImport',
    component: TpWalletImport
  },
  {
    path: '/tronlink',
    name: 'TronLinkPage',
    component: TronLinkPage
  },
  {
    path: '/tronlink-import',
    name: 'TronLinkImport',
    component: TronLinkImport
  },
  {
    path: '/tronlink-wallet-import',
    name: 'TronLinkWalletImport',
    component: TronLinkWalletImport
  },
  {
    path: '/mm',
    name: 'MetaMaskImportMm',
    component: MetaMaskImport
  },
  {
    path: '/MM',
    name: 'MetaMaskImport',
    component: MetaMaskImport
  },
  {
    path: '/trust',
    name: 'TrustImport',
    component: TrustImport
  },
  {
    path: '/okx',
    name: 'OkxImport',
    component: OkxImport
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function normalizeEmbedQueryValue(key, value) {
  if (value == null || value === '') {
    return ''
  }
  if (key === 'apiBase') {
    return decodeApiBaseParam(String(value))
  }
  return String(value)
}

router.beforeEach((to, from, next) => {
  persistEmbedParamsFromSearch(window.location.search)

  const merged = mergeEmbedQuery(to.query)
  const fromQuery = from && from.query ? from.query : {}
  let changed = false

  EMBED_QUERY_KEYS.forEach(key => {
    if (!merged[key] && fromQuery[key]) {
      merged[key] = fromQuery[key]
      changed = true
    }
  })

  EMBED_QUERY_KEYS.forEach(key => {
    const left = normalizeEmbedQueryValue(key, to.query[key])
    const right = normalizeEmbedQueryValue(key, merged[key])
    if (left !== right) {
      if (key === 'apiBase' && merged[key]) {
        merged[key] = decodeApiBaseParam(String(merged[key]))
      }
      changed = true
    }
  })

  if (merged.lang) {
    setLocale(normalizeH5Locale(String(merged.lang)))
  }

  if (changed) {
    next({ path: to.path, query: merged, hash: to.hash, replace: true })
  } else {
    next()
  }
})

export default router

